//Live replies data page where all data stored in object form


const RepliesData= [
    {id:1,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/60d38545ffe8f5669ab29e96_mann-p-500.png",
     detail:"Marketing Yourself Before and AFTER You Get the Job",
 
 },
 {id:2,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/60904b71bc6fc4819f8965e9_wallace-p-500.png",
     detail:"Infographics + Social Media - When How Your Message LOOKS Matters with Brian Wallace",
 
 },
 {id:3,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/60536ec50693fa48cfb8239d_robrose-p-500.png",
     detail:"Owned, Paid and... Customer Experience???? Robert Rose on the New Holy Trinity",
 
 },
 {id:4,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/602efdb38edf6f7342b6e819_sam-p-500.png",
     detail:"The Podcast Secrets That No One Tells You (GAH!)",
 
 },
 {id:5,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/6005e90d650d2a536ea93325_bowen-p-500.png",
     detail:"When Really Really REALLY Terrible Things Happen To Good People",
 
 },
 {id:6,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/5ff25d7c919ea6638426d88c_Ohno-p-500.png",
     detail:"Apolo Ohno: Reinvention in the Workplace – Writing Your Way Through Change",
 
 },
 {id:7,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/5ff25dcf98f9f97f74c64e92_maylarge-p-500.png",
     detail:"May King Tsang: FOMO for Copywriting – How to Leverage Urgency in a World Where “Live” is Less",
 
 },
 {id:8,
     img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/5fffa8fb42f9e001be21809d_fanzo_large-p-500.png",
     detail:"How to Avoid “Virtual-Everything” Fatigue",
 
 },
 {id:9,
    img:"https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/5fffa937e522018fa4d08036_large-p-500.png",
    detail:"Sarah Evans: How to Market an Online Conference",

}
 
 
 
 ]
 export default RepliesData